<template>
    <div class="container-fluid">
        <loading :active.sync="bool_fullLoading"></loading>

        <div class="pageHeader">
            <h2 id="titleHeight">{{ this.getUserInfo.DN }}'s {{this.getLanguage["PF"]["CM"]}}</h2>
        </div>

        <div class="contentWrapper" id="customizeMenuPage">
            <CRow class="m-4 py-4">
                <CCol lg="12" style="position: sticky; top: 70px; z-index: 21; background: #fff; ">
                    <div class="row">
                        <label class="col-form-label py-0 col-md-3">{{getLanguage["PF"]["DM"]}}</label>
                        <div class="col-md-8" style="display:flex;gap:30px;">
                            <div class="" style=" display: flex; align-items: center; gap: 5px;">
                                <input type="radio" :value="1" id="fullMenu" name="fullMenu" v-model="obj_P.MS" @click="sysAutoRunMenuType = false">
                                <label for="fullMenu">{{getLanguage["PF"]["FM"]}} </label>
                            </div>
                            <div class="" style=" display: flex; align-items: center; gap: 5px;">
                                <input type="radio" :value="2" id="simpleMenu" name="simpleMenu" v-model="obj_P.MS" @click="sysAutoRunMenuType = false">
                                <label for="simpleMenu">{{getLanguage["PF"]["SM"]}} </label>
                                <span class="custom_tooltip">
                                    <i class="fa fa-question-circle"></i>
                                    <span class="tooltiptext2 campaign-name">{{getLanguage["PF"]["SMD"]}}</span>
                                </span>
                            </div>
                            <div class="" style=" display: flex; align-items: center; gap: 5px;">
                                <input type="radio" :value="3" id="customizeMenu" name="customizeMenu" v-model="obj_P.MS" @click="sysAutoRunMenuType = false">
                                <label for="customizeMenu">{{getLanguage["PF"]["CM"]}}</label>
                            </div>
                        </div>

                        <label class="col-form-label py-0 col-md-3 mt-2">
                            {{getLanguage["PF"]["SMC"]}}
                            <span class="custom_tooltip">
                                <i class="fa fa-question-circle"></i>
                                <span class="tooltiptext2 campaign-name" style=" top: 0% !important; height: 130px; width: 210px !important;">
                                    {{getLanguage["SMB"]["CATD"]}}

                                    <img src="../../assets/images/menucategory.png" width="200" />
                                </span>
                            </span>
                        </label>
                        <div class="col-md-8 mt-2" style="display: flex; gap: 30px;">
                            <label class="switch" >
                                <input type="checkbox" :checked="obj_P.EL2MC" v-model="obj_P.EL2MC">
                                <span class="slider round"></span>
                            </label>
                        </div>

                        <div class="col-md-3"></div>
                        <div class="col-md-8">
                            <CButton size="sm" color="success" class="my-2" @click="saveMenu()">
                                <i class='fa fa-save'></i> {{this.getLanguage["BTN"]["SV"]}}
                            </CButton>
                        </div>
                    </div>

                    <div class="text-center pointer" style="top: .5rem; position: absolute; right: 0px; font-size: 12px;" @click="collapseAllMenu = false">
                        <i class="fa fa-expand d-block" style="font-size:20px"></i>
                        {{this.getLanguage["BTN"]["EXPANDA"]}}
                    </div>
                    <div class="text-center pointer" style="top: .5rem; position: absolute; right: 75px; font-size: 12px;" @click="collapseAllMenu = true;showSubMenu = null">
                        <i class="fa fa-compress d-block" style="font-size:20px"></i>
                        {{this.getLanguage["BTN"]["COLLAPSEA"]}}
                    </div>
                </CCol>
                <CCol lg="4">
                    <CSidebar style="position: relative;z-index:20" class="py-0">
                        <div class="scroll">
                            <ul class="c-scroll-area c-sidebar-nav ps" style="position: relative;z-index: 5;">
                                <template v-for="(menuTitle, index) in obj_menuTitle">
                                    <li v-if="menuTitle.C == false && checkMenuAccess(menuTitle.MN) && menuTitle.HSM == false" class="c-sidebar-nav-dropdown" :class="[(showSubMenu == menuTitle.MN || !collapseAllMenu ? 'c-show' : ''),(showActiveMenu.includes(menuTitle.PM)  || (showSubSubMenu && (menuTitle.PM == 'R' || menuTitle.PM == 'P' || menuTitle.PM == 'AGS' || menuTitle.PM == 'WEBS'|| menuTitle.PM == 'TOOLS' )) ? 'activeLvl1' : '')]">
                                        <a class="c-sidebar-nav-dropdown-toggle" v-if="menuTitle.HSM == false" v-on:click="changeShowSubMenu(menuTitle.MN)">
                                            <i :class="renderIcon(menuTitle.MN)"></i>
                                            <div class="menu-Name">
                                                <span>{{ menuTitle.MPI }}.</span>
                                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuTitle.MN) }}</span>
                                            </div>
                                            <input id="profile_checkbox" type="checkbox" :checked="!menuTitle.IHM" @click="checkAllMenuCategory($event, menuTitle.MN);" style=" position: absolute; right: 35px;" />
                                        </a>
                                        <ul class="c-sidebar-nav-dropdown-items">
                                            <template v-for="(menuSubmenu, index) in obj_menuTitle">
                                                <span v-if="menuSubmenu.C && menuSubmenu.PM == menuTitle.MN && menuSubmenu.HSM == false">
                                                <li class="c-sidebar-nav-item" v-if="checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.ISF != true && menuSubmenu.MN != 'VEC' && menuSubmenu.MN != 'VEB' && menuSubmenu.MN != 'VDH' && menuSubmenu.MN != 'CRMDU' && menuSubmenu.MN != 'LCHAT' && menuSubmenu.MN != 'UM'  && menuSubmenu.MN != 'VG' && menuSubmenu.MN != 'SAGTWL' && menuSubmenu.MN != 'STWO' && menuSubmenu.MN != 'VOTSB' " v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN && (showSubSubMenu !='RS6')}">
                                                    <a href="javascript:void(0)" id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="menuSubmenu.IHM = !menuSubmenu.IHM">
                                                        <div class="dropdown-Name">
                                                            <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                                                            <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuSubmenu.MN) }}</span>
                                                            <span>
                                                                <span v-if="!menuSubmenu.ESA && !menuSubmenu.EMA && !menuSubmenu.EAG" class="mandatory_Field">&nbsp;**</span>
                                                                <input id="profile_checkbox" type="checkbox" :checked="!menuSubmenu.IHM" />
                                                            </span>
                                                        </div>
                                                    </a>
                                                </li>
                                                <li class="c-sidebar-nav-item" v-else-if="checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view) && menuSubmenu.MN == 'SAGTWL' " v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                                                    <a href="javascript:void(0)" id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="menuSubmenu.IHM = !menuSubmenu.IHM">
                                                        <div class="dropdown-Name">
                                                            <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                                                            <span v-if="getUserInfo.AT === 4">{{ getLanguage["SMB"]["NTWL"] }}</span>
                                                            <span v-else>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                                                            <span><input id="profile_checkbox" type="checkbox" :checked="!menuSubmenu.IHM" /></span>
                                                        </div>
                                                    </a>
                                                </li>

                                                <li class="c-sidebar-nav-item" v-else-if="(menuTitle.MN == 'D' || menuTitle.MN == 'W' || menuTitle.MN == 'P') && checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.add)" v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                                                    <a href="javascript:void(0)" id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="menuSubmenu.IHM = !menuSubmenu.IHM">
                                                        <div class="dropdown-Name">
                                                            <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.add) }}</span>
                                                            <span>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                                                            <span><input id="profile_checkbox" type="checkbox" :checked="!menuSubmenu.IHM" /></span>
                                                        </div>
                                                    </a>
                                                </li>

                                                <li class="c-sidebar-nav-item" v-else-if="((menuSubmenu.MN == 'VG') || (menuSubmenu.MN == 'UM')) && checkModuleAccess(menuSubmenu.MN, menuTitle.MN, constAccessType.view)" v-on:click="changeShowActiveMenu(menuTitle.MN + '.' + menuSubmenu.MN)" v-bind:class="{ 'menuActive' : showActiveMenu == menuTitle.MN + '.' + menuSubmenu.MN}">
                                                    <a href="javascript:void(0)" id="subSubMenu" class="c-sidebar-nav-link" target="_blank" @click="menuSubmenu.IHM = !menuSubmenu.IHM">
                                                        <div class="dropdown-Name">
                                                            <span>{{ checkModuleIndex(menuSubmenu.MN, menuTitle.MN, constAccessType.view) }}</span>
                                                            <span>{{ getLanguage["SMB"][menuSubmenu.MN] }}</span>
                                                            <span><input id="profile_checkbox" type="checkbox" :checked="!menuSubmenu.IHM" /></span>
                                                        </div>
                                                    </a>
                                                </li>
                                                </span>
                                                <span v-if="menuSubmenu.PM == menuTitle.MN && menuSubmenu.HSM == true && menuSubmenu.SMN.length > 0 && checkSubModuleAccess(menuSubmenu.SMN)">
                                                <li class="c-sidebar-nav-item c-sidebar-nav-dropdown" v-if="checkMenuAccess(menuSubmenu.MN)" v-on:click="changeShowSubSubMenu(menuSubmenu.SMN)" :class="[((showSubSubMenu == menuSubmenu.SMN || !collapseAllMenu)  ? 'menuActive c-show' : ''),(showSubSubMenu.includes(menuTitle.SPM) ? 'activeLvl2' : '')]" :style="{cursor: obj_P.EL2MC ? 'pointer' : 'none',display: obj_P.EL2MC ? 'block' : 'none'}">
                                                    <div class="activeLvl2Div">
                                                        <a href="javascript:void(0)" id="subSubMenu" class="c-sidebar-nav-link c-sidebar-nav-dropdown-toggle haveSubMenu" target="_self">
                                                            <div class="dropdown-Name">
                                                                <span>{{ checkSubModuleIndex(menuSubmenu.MPI, menuSubmenu.PM, menuSubmenu.SMN, menuSubmenu.SMI) }}</span>
                                                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuSubmenu.SMN) }}</span>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </li>
                                                <template v-for="(menuSubModulemenu, index) in obj_menuTitle">
                                                    <span :class="!obj_P.EL2MC ? '' : 'level3'" v-if="menuSubModulemenu.C && menuSubModulemenu.SPM == menuSubmenu.SMN && menuSubModulemenu.HSM == true">
                                                    <li class="c-sidebar-nav-item" v-if="checkModuleAccess(menuSubModulemenu.MN, menuTitle.MN, constAccessType.view)" v-on:click="changeShowActiveMenu(menuSubModulemenu.PM + '.' + menuSubModulemenu.MN)" v-bind:class="{ 'menuActive' : showActiveMenu == menuTitle.MN + '.' + menuSubModulemenu.MN, 'd-block': ((showSubSubMenu == menuSubModulemenu.SPM) || !collapseAllMenu || !obj_P.EL2MC), 'd-none': ((showSubSubMenu != menuSubModulemenu.SPM) || !collapseAllMenu || obj_P.EL2MC) }" style="animation: fadeIn .5s; ">
                                                        <a href="javascript:void(0)" id="subSubMenu" class="c-sidebar-nav-link" target="_self" @click="menuSubModulemenu.IHM = !menuSubModulemenu.IHM">
                                                            <div class="dropdown-Name" :class="obj_P.EL2MC ? 'dropdown-SubName' : ''">
                                                                <span>{{ checkModuleIndex(menuSubModulemenu.MN, menuTitle.MN, constAccessType.view, menuSubmenu.SMN, menuSubmenu.SMI) }}</span>
                                                                <span v-if="menuSubModulemenu.MN == 'DR2'">{{ getLanguageOEMI(int_OEMId,"SMB","D") }}</span>
                                                                <span v-else-if="menuSubModulemenu.MN == 'WR2'">{{ getLanguageOEMI(int_OEMId,"SMB","W") }}</span>
                                                                <span v-else>{{ getLanguageOEMI(int_OEMId,"SMB",menuSubModulemenu.MN) }}</span>
                                                                <span><input id="profile_checkbox" type="checkbox" :checked="!menuSubModulemenu.IHM" /></span>
                                                            </div>
                                                        </a>
                                                    </li>
                                                    </span>
                                                </template>
                                                </span>
                                            </template>
                                        </ul>
                                    </li>

                                    <!-- custom for promo rules only (simplify menu) -->
                                    <li v-if="menuTitle.C == false && (menuTitle.MN == 'PRS' && menuTitle.PM == 'PRS') && menuTitle.HSM == false" :class="[(showSubMenu == menuTitle.MN ? 'c-sidebar-nav-dropdown c-show' : '')]">
                                        <a href="javascript:void(0)" class="c-sidebar-nav-dropdown-toggle after-none" @click="menuTitle.IHM = !menuTitle.IHM">
                                            <i :class="renderIcon(menuTitle.MN)"></i>
                                            <div class="menu-Name">
                                                <span>{{ menuTitle.MPI }}.</span>
                                                <span>{{ getLanguageOEMI(int_OEMId,"SMB",menuTitle.MN) }}</span>
                                            </div>
                                            <div><input id="profile_checkbox" type="checkbox" style="height: 16px; width: 16px; margin-top: 1px; position: absolute; right: 35px; top: 7px; accent-color: #321fdb" :checked="!menuTitle.IHM" /></div>
                                        </a>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </CSidebar>
                </CCol>
            </CRow>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import { required, sameAs, requiredIf, minLength, email } from "vuelidate/lib/validators";
    import genericHelper from "@/modules/GenericHelper.js";
    import Loading from "vue-loading-overlay";
    import 'vue-loading-overlay/dist/vue-loading.css';
    import { constAccessType, constMenuIcon } from '@/modules/Constant.js';
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import $ from 'jquery'

    function validatePassword(value) {
        if (this.obj_P.UP != null && this.obj_P.UP != '') {

            var pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[@#$%^&+=!])[A-Za-z\d@#$%^&+=!]{6,32}$/;

            return pattern.test(this.obj_P.UP);
        }
        return true;
    }

    export default {
        mixins: [genericHelper],
        components: {
            Loading,
            Treeselect,
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkMenuAccess', 'checkModuleAccess', 'checkModuleIndex', 'checkSubModuleAccess', 'checkSubModuleIndex']),
            isSimpleMode() {
                return this.$parent.isSimpleMode;
            },
        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_fullLoading: false,
                obj_P: {},
                obj_menuTitle: [],
                obj_menuTitleOri: [],
                obj_menuTitleHistory: [],
                constAccessType: constAccessType,
                constMenuIcon: constMenuIcon,
                int_OEMId: 0,
                minimize: false,
                isminimize: false,
                showSubMenu: "-1",
                showSubSubMenu: "-1",
                showActiveMenu: "-1",
                bool_fullpageLoading: false,
                collapseAllMenu: false,
                simplifyMenuItemSPA: ['ANAA', 'ANAN', 'ANMAN', 'ANMNT', 'ANSAN', 'ANSNT', 'LBAL', 'LDL', 'LL', 'LMEMWL', 'LMMWL', 'LMLO', 'LPL', 'LALO', 'LVLO', 'LWL', 'RR', 'RTWLBAG', 'SYSAL', 'SYSCRR', 'SYSSYS'],
                simplifyMenuItemSM: ['AGSAGS', 'AGSAGD', 'AGSASS', 'ANAA', 'ANAN', 'ANSAN', 'ANSNT', 'DASHDASH', 'DASHDBM', 'DASHDBP', 'RR', 'RTAS', 'RTWLBAG', 'RTWLBMA', 'RTWL', 'SYSSYS', 'SYSAL', 'SYSCRR', 'RBTL', 'RDR2', 'RWR2', 'RTR', 'RLR', 'RA1188FR', 'RABRBM'],
                simplifyMenuItemMA: ['AGSAGS', 'AGSAGD', 'AGSASS', 'ANAA', 'ANAN', 'ANSAN', 'ANSNT', 'DASHDASH', 'DASHDBM', 'DASHDBP', 'RR', 'RTAS', 'RTWLBAG', 'RTWLBMA', 'RTWL', 'SYSSYS', 'SYSAL', 'SYSCRR', 'RBTL', 'RDR2', 'RWR2', 'RTR', 'RLR', 'RA1188FR', 'RABRBM'],
                simplifyMenuItemA: ['CC','CCAL','CMDC','CMWC','CMWL','CCTS','CTNC','CCTL','CCL', 'AFFAFF', 'AFFAFFS', 'AGSAGS', 'AGSAGD', 'AGSASS', 'AGSGPLCBA', 'ANAA', 'ANAN', 'BB', 'WEBSWEBS', 'BACL', 'BMWB', 'DASHDASH', 'DASHDBM', 'DASHDBO', 'DD', 'DDDU', 'DDR', 'WWDU', 'WWR', 'GSGS', 'GSGSDU', 'MBLL', 'MM', 'MMCMI', 'MML', 'MMTS', 'MPAP', 'PDLSS', 'PLYT', 'PMSA', 'PP', 'PPD', 'PPDU', 'PPSE', 'RDR2', 'PTNMT', 'REBD', 'RR', 'RPR', 'RTR', 'RTAS', 'RTWLBAG', 'RTWL', 'RTWLBMA', 'RWINLV2', 'RWR2', 'SYSSYS', 'SYSAL', 'SYSCRR', 'WEBS', 'WEBSBA', 'WEBSCS', 'WEBSCMSDU', 'WEBSLC', 'WEBSPV', 'WW'],
                _isUpdatingMenu: false,
                userInteracted: false,
                sysAutoRunMenuType: false,
            }
        },
        validations: {
            obj_P: {
                U: { required },
                DN: { required },
                E: { email },
                OP: {
                    required: requiredIf(function (vm) {
                        return vm.UP != '';
                    }),
                },
                UP: {
                    minLength: value => !value || minLength(6)(value), validatePassword
                },
                CUP: {
                    required: requiredIf(function (vm) {
                        return vm.I == 0;
                    }),
                    sameAsPassword: sameAs(function (vm) { return vm.I == 0 || (vm.UP != '' && vm.UP != null) ? vm.UP : vm.CUP; })
                }
            },
        },
        methods: {
            ...mapActions('UserInfo', ['setUser', 'setMenuDisplayType']),
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_P[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.sameAsPassword != undefined && !validateObj.sameAsPassword) {
                        return this.getLanguage['ERR']['3001'];
                    }
                    else if ((validateObj.minLength != undefined && !validateObj.minLength) || (validateObj.maxLength != undefined && !validateObj.maxLength)) {
                        if (value == "UP") {
                            return this.getLanguage['AG']['IUPF'];
                        }
                        else {
                            return this.getLanguage['PF']['ERRMIN'];
                        }
                    }
                    else if (validateObj.email != undefined && !validateObj.email) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.minValue != undefined && !validateObj.minValue) {
                        return String.format(this.utilGetErrorLanguage('1005'), this.getLanguage["AG"][langKey]);
                    }
                    else if (validateObj.validatePassword != undefined && !validateObj.validatePassword) {
                        return this.getLanguage['AG']['IUPF'];
                    }
                }
            },
            getProfile() {
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/agt/g/0`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s) {
                        that.setProfileData(d.D);
                    }
                });
            },
            setProfileData(data) {
                var agi;
                this.obj_P = data;
                this.obj_P.UP = '';

                agi = (this.obj_P.AT == 4) ? this.obj_P.SAGAGI : this.obj_P.AGI;
                this.obj_P.ATAGI = this.obj_P.AT + "-" + agi;
            },
            saveProfile() {
                this.bool_CV = true;
                this.$v.obj_P.$touch();
                if (!this.$v.obj_P.$error) {
                    this.bool_fullLoading = true;
                    var that = this;
                    this.obj_P.IPF = 1;
                    this.postDataApi(`/api/agt/s`, this.obj_P, function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.getProfile();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                        }
                    });
                }
            },
            getmenuTitle(isSimpleMode) {
                var that = this;
                this.getDataApi(`/api/role/gv/0/0/` + isSimpleMode,
                    function (d, s) {
                        if (s) {
                            that.setmenuTitle(d);
                        }
                    });
            },
            setmenuTitle(data) {
                this.obj_menuTitleOri = JSON.parse(JSON.stringify(data.RoleAccessList));
                this.obj_menuTitle = JSON.parse(JSON.stringify(data.RoleAccessList));
                this._isFirstLoadMenu = false;

                if (this.isOUTMOB) {
                    var that = this;
                    var tempMenu = []; // temperory hide menu in outlet mobile
                    $.each(that.obj_menuTitle, function (index, elem) {
                        if (elem.PM == "DASH" || elem.PM == "P" || (elem.PM == "R" && elem.SMN == "RS2") || (elem.PM == "R" && elem.MN == "WINLV2") || (elem.PM == "R" && elem.MN == "SAGTWL") || (elem.PM == "R" && elem.SMN == "RS4") || elem.PM == "AFF" || elem.PM == "MS" || elem.PM == "L" || elem.PM == "D" || elem.PM == "W" || (elem.PM == "M" && elem.MN == "BLL") || (elem.PM == "GS" && elem.MN == "GSDU") || (elem.PM == "AGS" && elem.MN == "SUBHRY") || elem.ISF == true) {
                        } else {
                            tempMenu.push(elem)
                        }
                    });
                    that.obj_menuTitle = tempMenu;
                }

                if (this.$route.path == "/") {
                    var ParentModule = "";
                    var ModuleName = "";
                    for (var i = 0; i < this.obj_menuTitle.length; i++) {
                        if (this.obj_menuTitle[i].C && this.checkModuleAccess(this.obj_menuTitle[i].MN, this.obj_menuTitle[i].PM, constAccessType.view) && this.obj_menuTitle[i].MN != 'VEC' && this.obj_menuTitle[i].MN != 'VEB' && this.obj_menuTitle[i].MN != 'VDH' && this.obj_menuTitle[i].MN != 'VOTSB') {
                            var link = '/' + this.obj_menuTitle[i].PM + '/' + this.obj_menuTitle[i].MN;
                            ParentModule = this.obj_menuTitle[i].PM;
                            ModuleName = this.obj_menuTitle[i].MN;
                            this.$router.push(link);
                            break;
                        }
                    }
                    //this.isFirstLoad = (this.favMenuList != null && this.favMenuList.length > 0 && this.favMenuList.find(f => { return f.PM == ParentModule && f.MN == ModuleName }));
                } else {
                    var temp = this.showActiveMenu.split('.');
                    var ParentModule = "";
                    var ModuleName = "";
                    if (temp.length > 0) {
                        ParentModule = temp[0];
                        ModuleName = temp[1];
                    }
                    //this.isFirstLoad = (this.favMenuList != null && this.favMenuList.length > 0 && this.favMenuList.find(f => { return f.PM == ParentModule && f.MN == ModuleName }));
                }

                for (var i = 0; i < this.obj_menuTitle.length; i++) {
                    if (this.obj_menuTitle[i].C && this.checkModuleAccess(this.obj_menuTitle[i].MN, this.obj_menuTitle[i].PM, constAccessType.view) && this.obj_menuTitle[i].MN != 'VEC' && this.obj_menuTitle[i].MN != 'VEB' && this.obj_menuTitle[i].MN != 'VDH' && this.obj_menuTitle[i].MN != 'VOTSB' && this.obj_menuTitle[i].ISF == false) {
                        var link = '/' + this.obj_menuTitle[i].PM + '/' + this.obj_menuTitle[i].MN;
                        this.FisrtMenuItem = link;
                        break;
                    }
                }

                //TT11599 [BO Customize Menu] Enhance on Customize Menu
                //if (this.getUserInfo.AT == 1 || this.getUserInfo.AT == 2) {
                //    if (this.obj_menuTitle.length > 0) {
                //        this.obj_menuTitle = this.obj_menuTitle.filter(function (item) {
                //            return item.SMN !== "RS2";
                //        });
                //    }
                //}

                if (this.getUserInfo.MS === 1) {
                    this.obj_menuTitle.forEach(item => { item.IHM = false; });
                }
                else if (this.getUserInfo.MS === 2) {
                    let simplifyMenuList = this.getSimplifyList();
                    const simplifySet = new Set(simplifyMenuList);
                    this.obj_menuTitle.forEach(item => {
                        const isParent = item.MN === item.PM;
                        const key = item.PM + item.MN;
                        const shouldShow = simplifySet.has(key);
                        item.IHM = isParent ? !shouldShow : !shouldShow;
                    });
                }

                this.bool_fullpageLoading = false;
            },
            renderIcon(menuTitle) {
                return this.constMenuIcon[menuTitle];
            },

            changeShowSubMenu(MN) {
                this.$route.matched[0].name = this.getLanguage["SMB"][MN];

                if (this.showSubMenu == MN) {
                    this.showSubMenu = '';
                } else {
                    this.showSubMenu = MN;
                }
                // this.isFirstLoad = false;
            },
            changeShowSubSubMenu(SMN) {
                if (this.showSubSubMenu == SMN) {
                    this.showSubSubMenu = '';
                } else {
                    this.showSubSubMenu = SMN;
                }
            },
            changeShowActiveMenu(MN) {
                this.showActiveMenu = MN;

                if (this.showSubSubMenu == 'RS6' && this.showSubMenu != 'GS') {
                    this.showSubSubMenu = '';
                }

                if (!this.isOUTMOB) {
                    if (!this.showSubSubMenu) {
                        this.changeShowSubSubMenu('RS1')
                    }
                }
                else {
                    this.changeShowSubSubMenu('RS3')
                }


                //Game Settings collapse sub menu when click on other menu
                if (MN.split(".")[0] == "GS" && (
                    MN.split(".")[1] != "GPS" && MN.split(".")[1] != "M888S" &&
                    MN.split(".")[1] != "MV3S" && MN.split(".")[1] != "P888S" &&
                    MN.split(".")[1] != "K918S" && MN.split(".")[1] != "A288S" &&
                    MN.split(".")[1] != "AFBCS" && MN.split(".")[1] != "LG88S" &&
                    MN.split(".")[1] != "GD88S" && MN.split(".")[1] != "IGS" &&
                    MN.split(".")[1] != "NKS" && MN.split(".")[1] != "W9S"
                )) {
                    if (!this.isOUTMOB) {
                        this.changeShowSubSubMenu('RS1');
                    }
                    else {
                        this.changeShowSubSubMenu('RS3');
                    }
                }


                // when click report will auto minimize sidemenu
                if (MN.split(".")[0] == "R") {
                    this.isminimize = true;
                    this.minimize = true;
                } else {
                    this.isminimize = false;
                    this.minimize = false;
                }
            },

            saveMenu() {
                var that = this;
                if (this.obj_P.MS == 1 || this.obj_P.MS == 2) {
                    this.bool_fullLoading = true;
                    this.obj_P.IPF = 1;
                    this.postDataApi(`/api/agt/s`, this.obj_P, function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.$fire({
                                title: that.utilGetErrorLanguage("ERR.SS"),
                                html: that.utilGetErrorLanguage("GL.AS"),
                                width: '30em',
                                customClass: {
                                    title: 'afb-alert-title',
                                    content: 'afb-alert-content',
                                    actions: 'afb-alert-action'
                                }
                            }).then((result) => {
                                if (result.value == true) {
                                    that.$router.go(0);
                                }
                            });

                        }
                    });
                }
                else {
                    let hidden_menu_list = this.obj_menuTitle.filter(f => { return f.IHM == true && (f.PM != f.MN || f.MN == 'PRS') });
                    let str_menu_list = "";
                    if (hidden_menu_list && hidden_menu_list.length > 0) {
                        let ParentModuleList = [];
                        for (var i = 0; i < hidden_menu_list.length; i++) {
                            str_menu_list += (hidden_menu_list[i].PM + "[1]" + hidden_menu_list[i].MN + "[2]" + hidden_menu_list[i].SPM + "[3]" + hidden_menu_list[i].SMN + ",");
                            if (!ParentModuleList.includes(hidden_menu_list[i].PM + "#" + hidden_menu_list[i].SPM) && hidden_menu_list[i].PM != hidden_menu_list[i].MN)
                                ParentModuleList.push(hidden_menu_list[i].PM + "#" + hidden_menu_list[i].SPM);
                        }
                        if (ParentModuleList && ParentModuleList.length > 0) {
                            // Hide parent module if all sub modules are hide
                            for (var i = 0; i < ParentModuleList.length; i++) {
                                let ArrayStr = ParentModuleList[i].split("#");
                                let parentModule = this.obj_menuTitle.find(f => { return f.IHM == false && f.PM == ArrayStr[0] && f.MN != ArrayStr[0] && ((ArrayStr[1] && f.SPM == ArrayStr[1]) || !ArrayStr[1]) && f.SPI > 0 && !f.ISF && this.checkModuleAccess(f.MN, f.PM, constAccessType.view) });
                                if (parentModule == undefined) {
                                    str_menu_list += (ArrayStr[0] + "[1]" + ArrayStr[0] + "[2][3]" + ArrayStr[1] + ",");
                                }
                            }

                            // Hide report menu if no submenu
                            let parentModule = this.obj_menuTitle.find(f => { return f.IHM == false && f.PM == "R" && f.SPM != '' && f.SPI > 0 && !f.ISF && this.checkModuleAccess(f.MN, f.PM, constAccessType.view) });
                            if (parentModule == undefined) {
                                str_menu_list += ("R[1]R[2][3]" + ",");
                            }
                        }
                        str_menu_list = str_menu_list.slice(0, -1);
                    }

                    this.bool_fullLoading = true;
                    this.postDataApi(`/api/role/hidemenu`, { 'IHM': this.isSimpleMode, 'MN': str_menu_list },
                        function (d, s) {
                            //that.bool_fullLoading = false;
                            if (s) {
                                that.obj_P.IPF = 1;
                                that.postDataApi(`/api/agt/s`, that.obj_P, function (d, s) {
                                    that.bool_fullLoading = false;
                                    if (s) {
                                        that.$fire({
                                            title: that.utilGetErrorLanguage("ERR.SS"),
                                            html: that.utilGetErrorLanguage("GL.AS"),
                                            width: '30em',
                                            customClass: {
                                                title: 'afb-alert-title',
                                                content: 'afb-alert-content',
                                                actions: 'afb-alert-action'
                                            }
                                        }).then((result) => {
                                            if (result.value == true) {
                                                that.$router.go(0);
                                            }
                                        });

                                    }
                                });
                            }
                        });
                }
            },
            checkAllMenuCategory(event, title) {
                const isChecked = event.target.checked;

                // Update IHM of child items by category
                this.obj_menuTitle = this.obj_menuTitle.map(menu => {
                    if (menu.PM === title) {
                        return {
                            ...menu,
                            IHM: !isChecked
                        };
                    }
                    return menu;
                });
            },
            getSimplifyList() {
                const AT = this.getUserInfo.AT;
                if (AT === 0) return this.simplifyMenuItemSPA;
                if (AT === 1) return this.simplifyMenuItemSM;
                if (AT === 2) return this.simplifyMenuItemMA;
                if (AT === 3) return this.simplifyMenuItemA;
                return [];
            },

            handleMenuTitleUpdate() {
                if (!Array.isArray(this.obj_menuTitle) || this._isUpdatingMenu) return;
                this._isUpdatingMenu = true;

                if (this.obj_P.MS === 1 || this.obj_P.MS === 2) {
                    const simplifyList = this.getSimplifyList();
                    const simplifySet = new Set(simplifyList);
                    const fullmenu = this.obj_menuTitle.every(item => item.IHM === false);
                    if (fullmenu) {
                        this.obj_P.MS = 1;
                    }
                    else {
                        const nonIhmItems = this.obj_menuTitle.filter(i => !i.IHM);
                        const ihmItems = this.obj_menuTitle.filter(i => i.IHM);

                        for (const item of nonIhmItems) {
                            const key = item.PM + item.MN;
                            if (item.MN !== item.PM && item.SPI > 0 && !item.ISF && simplifySet.has(key)) {
                                let matchedPN2 = null;

                                for (const ihmItem of ihmItems) {
                                    const key2 = ihmItem.PM + ihmItem.MN;
                                    if (ihmItem.MN !== ihmItem.PM && ihmItem.SPI > 0 && !ihmItem.ISF && simplifySet.has(key2)) {
                                        this.obj_menuTitleHistory = JSON.parse(JSON.stringify(this.obj_menuTitle));
                                        this.sysAutoRunMenuType = true;
                                        this.obj_P.MS = 3;
                                        matchedPN2 = ihmItem.PM;
                                        break;
                                    }
                                }

                                if (matchedPN2) {
                                    const parent = this.obj_menuTitle.find(i => i.PM === i.MN && i.MN === matchedPN2);
                                    if (parent) parent.IHM = false;
                                }
                                else {
                                    this.obj_menuTitleHistory = JSON.parse(JSON.stringify(this.obj_menuTitle));
                                    this.sysAutoRunMenuType = true;
                                    this.obj_P.MS = 2;
                                }
                            }
                            else if (!simplifySet.has(key)) {
                                this.obj_menuTitleHistory = JSON.parse(JSON.stringify(this.obj_menuTitle));
                                this.sysAutoRunMenuType = true;
                                this.obj_P.MS = 3;
                                break;
                            }
                        }
                    }
                }
                else if (this.obj_P.MS == 3) {
                    this.obj_menuTitleHistory = JSON.parse(JSON.stringify(this.obj_menuTitle));
                }

                this.$nextTick(() => {
                    this._isUpdatingMenu = false;
                });
            }
        },
        created() {
            this.int_OEMId = this.getUserInfo.OEMI;
            this.getProfile();

            if (localStorage.getItem('isSimpleMode') === 'False') {
                this.setMenuDisplayType(0)
                this.getmenuTitle(0);
            } else {
                this.setMenuDisplayType(1)
                this.getmenuTitle(1);
            }
            this.changeShowActiveMenu(this.$parent.showActiveMenu);

            if (!this.isSimpleMode) {
                this.$parent.isSimpleMode = true;
            }
        },
        mounted() {
            $('#customizeMenuPage').one('click', () => {
                this.userInteracted = true;
                this.handleMenuTitleUpdate();
            });
        },
        watch: {
            isSimpleMode() {
                this.obj_menuTitle = [];
                this.bool_fullpageLoading = true;

                const mode = this.isSimpleMode ? 1 : 0;
                localStorage.setItem('isSimpleMode', this.isSimpleMode ? 'True' : 'False');
                this.setMenuDisplayType(mode);
                this.getmenuTitle(mode);
            },
            'obj_P.MS': {
                handler: function (newVal, oldVal) {
                    if (!newVal || !this.obj_menuTitle || !this.obj_menuTitle.length) return;
                    if (newVal === 1) {
                        this.obj_P.EL2MC = true;
                        this.obj_menuTitle.forEach(item => { item.IHM = false; });
                    }
                    else if (newVal === 2) {
                        this.obj_P.EL2MC = false;
                        let simplifyMenuList = this.getSimplifyList();
                        const simplifySet = new Set(simplifyMenuList);
                        this.obj_menuTitle.forEach(item => {
                            const isParent = item.MN === item.PM;
                            const key = item.PM + item.MN;
                            const shouldShow = simplifySet.has(key);
                            item.IHM = isParent ? !shouldShow : !shouldShow;
                        });
                    }
                    else if (newVal === 3) {
                        if (this.sysAutoRunMenuType) {
                            this.obj_menuTitle = JSON.parse(JSON.stringify(this.obj_menuTitleHistory));
                        } else {
                            this.obj_menuTitle = JSON.parse(JSON.stringify(this.obj_menuTitleOri));
                        }
                    }
                }
            },
            obj_menuTitle: {
                handler: function (newVal, oldVal) {
                    if (!newVal || !Array.isArray(newVal) || newVal.length == 0) return; // <- guard here!
                    if (this.userInteracted) {
                        this.handleMenuTitleUpdate();
                    }
                    // hide parent if all its children are hidden
                    const parentItemsMap = {};
                    const groupedByPM = {};
                    newVal.forEach(item => {
                        if (item.PM === item.MN) {
                            parentItemsMap[item.MN] = item;
                        } else if (item.SPI > 0 && !item.ISF) {
                            if (!groupedByPM[item.PM]) groupedByPM[item.PM] = [];
                            groupedByPM[item.PM].push(item);
                        }
                    });

                    for (const pm in groupedByPM) {
                        const allHidden = groupedByPM[pm].every(i => i.IHM);
                        if (parentItemsMap[pm]) {
                            parentItemsMap[pm].IHM = allHidden;
                        }
                    }
                },
                deep: true
            }
        },
    }

</script>

<style scoped>
    .contentWrapper {
        background: #fff;
        width: 100%;
        margin-top: 1rem;
        margin-left: -15px;
        margin-right: -15px;
    }


    .col-form-label {
        font-weight: bold;
    }

    input[type="checkbox"]#profile_checkbox {
        -webkit-appearance: none; /* Remove default styles for WebKit browsers */
        -moz-appearance: none; /* Remove default styles for Firefox */
        appearance: none;
        width: 16px;
        height: 16px;
        background-color: #f0f0f0; /* Default background color */
        border: 1px solid #ccc;
        border-radius: 2px;
        cursor: pointer;
        margin-top: 1px;
    }

        input[type="checkbox"]#profile_checkbox:checked {
            background-color: rgb(50, 31, 219); /* Background color when checked */
            border-color: rgb(0 0 0);
        }

            input[type="checkbox"]#profile_checkbox:checked:disabled {
                background-color: rgb(115 111 143); /* Background color when checked */
                border-color: rgb(115 111 143);
                opacity: .5;
                cursor: default;
            }

            input[type="checkbox"]#profile_checkbox:checked::before {
                content: "\2713"; /* Unicode for checkmark */
                display: block;
                text-align: center;
                color: white;
                font-size: 14px;
                line-height: 14px;
            }

    .col-lg-12 label.col-form-label::after {
        content: ":";
        float: right;
    }
</style>



// WEBPACK FOOTER //
// src/components/Page/CustomizeMenu.vue